<template>
  <section>
    <!-- breadcrumb -->
    <div class="breadcrumb-top">
      <b-breadcrumb class="">
        <b-breadcrumb-item :to="{ name: 'dashboard' }" >
          <feather-icon
            icon="HomeIcon"
            size="16"
          />
        </b-breadcrumb-item>
        <b-breadcrumb-item>
          Fulfillment
        </b-breadcrumb-item>
        <b-breadcrumb-item :to="{ name: 'inbound' }" >
          inbound
        </b-breadcrumb-item>
        <b-breadcrumb-item active >
          {{$route.params.id}}
        </b-breadcrumb-item>
      </b-breadcrumb>
    </div>

    <b-button
      variant="flat-secondary"
      class="ll-cancel"
      :to="{ name: 'inbound' }"
    >
      <!-- <feather-icon icon="RotateCcwIcon" /> -->
      <b-img
        :src="require('@/assets/images/imgs/return.png')"
        height="auto"
        class="mr-1"
      />
    </b-button>

    <!-- first floor -->
    <b-row>
      <b-col
        md="2"
        class="ll-p"
      >
        <b-card
          class="ll-c ll-4"
          header="ASN No"
          :title="baseInfo.invoiceNo"
        >
        </b-card>
      </b-col>
      <b-col
        md="2"
        class="ll-p"
      >
        <b-card
          class="ll-c ll-4"
          header="Status"
          :title="baseInfo.status"
        >
        </b-card>
      </b-col>
      <b-col
        md="2"
        class="ll-p"
      >
        <b-card
          class="ll-c ll-4"
          header="Order Type"
          :title="baseInfo.createdAt"
        >
        </b-card>
      </b-col>
      <b-col
        md="2"
        class="ll-p"
      >
        <b-card
          class="ll-c ll-4"
          header="Planned Total SKU"
          :title="baseInfo.quantity"
        >
        </b-card>
      </b-col>
      <b-col
        md="2"
      >
        <b-card
          class="ll-c ll-4"
          header="Planned Total Qty"
          :title="baseInfo.totalAmount"
        >
        </b-card>
      </b-col>
      <b-col
        md="2"
      >
        <b-card
          class="ll-c ll-4"
          header="ASN Total Value"
          :title="baseInfo.totalAmount"
        >
        </b-card>
      </b-col>
    </b-row>
    <!-- second floor -->
    <b-row>
      <b-col
        md="6"
        lg="9"
        class="ll-p"
      >
      <b-card
        no-body
        class="card-browser-states ll-r ll-6 ll-hei"
        >
          <b-card-header>
            <b-card-title>ASN Detail</b-card-title>
          </b-card-header>
          <b-card-body>
            <b-row>
              <b-col
                lg="4"
                class="ll-p"
              >
                <b-form-group
                  label="Custom Name"
                  label-for="s"
                >
                  <b-form-input readonly/>
                </b-form-group>
              </b-col>
              <b-col
                lg="4"
                class="ll-p"
              >
                <b-form-group
                  label="Owner"
                  label-for="s"
                >
                  <b-form-input readonly/>
                </b-form-group>
              </b-col>
              <b-col
                lg="4"
                class="ll-p"
              >
                <b-form-group
                  label="Warehouse Code"
                  label-for="s"
                >
                  <b-form-input readonly/>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col
                lg="4"
                class="ll-p"
              >
                <b-form-group
                  label="ASN Creation Date"
                  label-for="s"
                >
                  <b-form-input readonly/>
                </b-form-group>
              </b-col>
              <b-col
                lg="4"
                class="ll-p"
              >
                <b-form-group
                  label="Order Creation Time"
                  label-for="s"
                >
                  <b-form-input readonly/>
                </b-form-group>
              </b-col>
              <b-col
                lg="4"
                class="ll-p"
              >
                <b-form-group
                  label="ETA Date"
                  label-for="s"
                >
                  <b-form-input readonly/>
                </b-form-group>
              </b-col>
            </b-row>
          </b-card-body>
       </b-card>
      </b-col>
      <b-col
        md="6"
        lg="3"
        class="ll-p"
      >
        <b-card
          no-body
          class="border-primary ll-c ll-6 ll-hei">
          <b-card-header>
            <b-card-title>Inbound Summary</b-card-title>
          </b-card-header>
          <b-card-body>
            <b-row>
              <b-col lg="3" class="ll-imgBox">
                <b-img
                  :src="require('@/assets/images/imgs/1.jpg')"
                  height="auto"
                  width="100%"
                  class="mr-1"
                />
              </b-col>
              <b-col lg="9">
                <div class="ll-box">
                  <label class="ll-lab">Putaway Time</label>
                  <span class="ll-span">test</span>
                </div>
                <div class="ll-box">
                  <label class="ll-lab">Total Inbound SKU</label>
                  <span class="ll-span"></span>
                </div>
                <div class="ll-box">
                  <label class="ll-lab">Total Inbound Qty</label>
                  <span class="ll-span"></span>
                </div>
                <div class="ll-box">
                  <label class="ll-lab">Total Worn Qty</label>
                  <span class="ll-span"></span>
                </div>
                <div class="ll-box">
                  <label class="ll-lab">Total Tradeable Qty</label>
                  <span class="ll-span"></span>
                </div>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col
        md="12"
        class="ll-p"
      >
      <b-card
        no-body
        class="card-browser-states ll-r ll-6"
        >
          <b-card-header>
            <b-card-title>Inbound Item List</b-card-title>
          </b-card-header>
          <b-card-body class="ll-cb">
            <b-table :items="items" :fields="fields" :borderless='false' :hover="true">
            </b-table>
            <div class="d-flex justify-content-between flex-wrap ll-page" v-if="false">
              <div class="d-flex align-items-center mb-0 mt-1">
                <span class="text-nowrap ">
                  Showing 1 to
                </span>
                <b-form-select
                  v-model="size"
                  :options="pageOptions"
                  class="mx-1"
                  @input="handlePageChange"
                />
                <span class="text-nowrap"> of {{ totalSize }} entries </span>
              </div>
              <div>
                <b-pagination
                  v-model="page"
                  :total-rows="totalSize"
                  :per-page="size"
                  first-number
                  last-number
                  class="mb-0 mt-1 mt-sm-0"
                  prev-class="prev-item"
                  next-class="next-item"
                  @change="handleChangePage"
                >
                  <template #prev-text>
                    <feather-icon
                      icon="ChevronLeftIcon"
                      size="18"
                    />
                  </template>
                  <template #next-text>
                    <feather-icon
                      icon="ChevronRightIcon"
                      size="18"
                    />
                  </template>
                </b-pagination>
              </div>
            </div>
          </b-card-body>
       </b-card>
      </b-col>
    </b-row>
  </section>
</template>

<script>
import {
  BRow, BCol, BCard, BFormInput, BTable,
  BButton, BImg,
  BCardHeader, BCardTitle, BCardBody,
  BBreadcrumb,
  BBreadcrumbItem,
  BFormSelect,
  BPagination, BFormGroup,
} from 'bootstrap-vue'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BFormGroup,
    BFormInput,
    BCardHeader,
    BCardTitle,
    BCardBody,
    BButton,
    BTable,
    BBreadcrumb,
    BBreadcrumbItem,
    BFormSelect,
    BPagination,
    BImg,
  },
  data() {
    return {
      pageOptions: [15, 25, 35],
      page: null, // 当前页码
      size: 15, // 每页个数
      totalSize: null, // 总个数
      totalPage: null, // 总页数
      searchPID: '',
      borderless: true,
      items: [],
      fields: [
        { key: 'id', label: '#' },
        { key: 'tkID', label: 'Item Code' },
        { key: 'status', label: 'Name' },
        { key: 'invoiceType', label: 'Description' },
        { key: 'feeType', label: 'Type' },
        { key: 'amount', label: 'Po No' },
        { key: 'date', label: 'Po Date' },
        { key: 'qty', label: 'Planned Qty' },
        { key: 'unit', label: 'Unit' },
        { key: 'act', label: 'Actual Qty' },
        { key: 'worn', label: 'Worn Qty' },
        { key: 'diff', label: 'Difference' },
        { key: 'tradea', label: 'Tradeable Qty' },
        { key: 'batch', label: 'Batch No' },
        { key: 'bar', label: 'Barcode' },
        { key: 'exp', label: 'Expiry Date' },
      ],
      jobTrack: {
        page: '1',
        size: '20',
        startEventTime: null,
        endEventTime: null,
        statusCode: null,
        orderBy: 'id',
        orderMole: '0',
        tkIDs: '',
      },
      baseInfo: {
        invoiceNo: '',
        status: null,
        createdAt: '',
        quantity: '',
        totalAmount: '',
      },
      account: {
        billToName: '',
        billToCompany: '',
        billToAddress1: '',
        billToCity: '',
        billToProvince: '',
        billToPostal: '',
        billToCountryCode: '',
        accountNumber: '',
        netDays: '',
        remitToName: '',
        remitToCity: '',
        remitToPostal: '',
        remitToCountryCode: '',
      },
      tags: [],
      condition: {
        page: '1',
        size: '15',
        orderBy: 'id',
        // orderMole: 0,
        status: null,
        invoiceType: null,
        beginDate: null,
        endDate: null,
        refNo: null,
        invoiceNo: null,
      },
    }
  },
  created() {},
  mounted() {
    // this.getDetails()
    // this.statusTrack()
  },
  methods: {
    // base info
    getDetails() {
      this.condition.invoiceNo = this.$route.params.id
      this.$http.post('invoiceDetail/search', this.condition).then(res => {
        // console.log(res.data.data)
        const info = res.data.data.content
        this.items = info
        const result = res.data.data
        this.page = result.page
        this.size = result.size
        this.totalSize = result.totalSize
        this.totalPage = result.totalPage
      })
    },
    // status tracking
    statusTrack() {
    },
    // 根据TKID查询
    handleSearch() {
      if (this.searchPID.trim() !== '') {
        this.condition.refNo = this.searchPID.trim()
        this.getDetails()
      } else {
        this.condition.refNo = null
        this.getDetails()
      }
    },
    handleChangePage(page) {
      console.log(page)
      this.condition.page = page
      this.getDetails()
    },
    handlePageChange(active) {
      console.log(active)
      this.condition.size = active
      this.getDetails()
    },
  },
}
</script>
<style scoped>
.ll-0{
  display: flex;
  justify-content: space-between;
  font-size: 14px;
}
.mb-0{
  font-size: 12px;
}
.ll-1{
  display: flex;
  width: 100%;
}
.ll-title{
  width: 70%;
  /* margin: auto; */
}
.ll-input{
  width: 30%;
}
.ll-p{
  padding: 0.5rem;
}
.ll-c{
  margin-bottom: 0;
}
.ll-c .card-header{
  font-weight: 500;
  font-size: 1.285rem;
}
.ll-c .card-body .card-title{
  font-weight: normal;
  /* font-size: 14px; */
}
.d-block{
  font-size: 14px;
}
.ll-h .col{
  text-transform: uppercase;
  font-size: 0.857rem;
  letter-spacing: 0.5px;
  font-weight: bold;
}
.ll-btn{
  position: fixed;
  bottom: 10px;
  text-align: center;
  width: 100%;
}
.ll-btn .btn-danger, .ll-btn .btn-primary{
  width: 30%;
}
.ll-3{
  margin-top: 10px;
}
.ll-3 div{
  padding: 0;
}
.g-label{
  justify-content: space-between !important;
}
.ll-4{
  height: 80px;
  background-color: unset;
  box-shadow: unset;
}
.ll-4 .card-header{
  font-weight: normal;
  font-size: 12px;
}
/* .ll-4 .card-body{
  text-align: center;
} */
.ll-4 .card-title{
  font-weight: 500 !important;
  font-size: 16px;
}
.ll-bform{
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.ll-6{
  /* height: 385px; */
  margin-bottom: 0px;
  overflow-y: auto;
}
.ll-trim{
  position: relative;
  left: 40px;
}
.ll-trim1{
  position: relative;
  left: 5px;
}
.ll-badge{
  padding: 5px;
  margin: 5px;
}
.ll-cb{
  margin: 1.5rem;
  margin-top: 0;
}
.ll-form {
  display: flex;
  justify-content: space-between;
}
.ll-tagBox{
  padding: 2rem 0.5rem;
}
.ll-hei{
  height: 220px;
}
.ll-bfBox{
  width: 100%;
  padding-right: 20px;
}
.ll-bfBox .ll-label{
  width: 30%;
}
.ll-bfBox .ll-inpBox{
  width: 70%;
}
.ll-imgBox{
  display: flex;
  align-items: center;
}
.ll-box{
  width: 90%;
  display: flex;
  justify-content: space-between;
  padding-bottom: 10px;
  padding-left: 6px;
}
.ll-box .ll-lab{
  font-weight: 500;
}
</style>
<style>
[dir] .table:not(.table-dark):not(.table-light) thead:not(.thead-dark) th{
  background-color: #fff;
}
[dir] .table thead th{
  border: none;
  padding: 5px;
}
.d-block{
  font-size: 14px;
}
[dir] .card .card-title {
  margin-bottom: 0.5rem;
}
[dir=ltr] .b-sidebar.b-sidebar-right{
  width: 28%;
}
.d-block{
  font-size: 12px;
}
.b-sidebar-header strong{
  width: 100%;
  text-align: center;
}
.table td {
    padding: 0.72rem;
}
.table thead th, .table tfoot th {
  text-transform: capitalize;
}
</style>
